// Import Types
import type { PartnerSettingsPermissionsKeys } from 'types';

const PARTNER_SETTINGS: Record<PartnerSettingsPermissionsKeys, PartnerSettingsPermissionsKeys> = {
    IsAllowPushNotification: 'IsAllowPushNotification',
    IsAllowPopUp: 'IsAllowPopUp',
    IsAllowDynamicPopUp: 'IsAllowDynamicPopUp',
    IsAllowCMSBanner: 'IsAllowCMSBanner',
    IsAllowCMSPopUp: 'IsAllowCMSPopUp',
    IsAllowABTest: 'IsAllowABTest',
    IsAllowAiSegmentation: 'IsAllowAiSegmentation',
    IsAllowAiTemplateEditing: 'IsAllowAiTemplateEditing',
    IsBonusIncluded: 'IsBonusIncluded',
    IsEmailTracked: 'IsEmailTracked',
    IsAllowNftBonus: 'IsAllowNftBonus',
    IsAllowViberNotification: 'IsAllowViberNotification',
    IsAllowInternalMessage: 'IsAllowInternalMessage',
    IsAllowHooryMessage: 'IsAllowHooryMessage',
    IsAllowWhatsApp: 'IsAllowWhatsApp',
    IsAllowWhatsAppProvider: 'IsAllowWhatsAppProvider',
    IsAllowTemplateCategory: 'IsAllowTemplateCategory',
    IsAllowEventNotifications: 'IsAllowEventNotifications',
    IsAllowMultiWalletCashBonus: 'IsAllowMultiWalletCashBonus',
    IsAllowViberSmsCascading: 'IsAllowViberSmsCascading',
    IsRequiredPromoBudgetLimit: 'IsRequiredPromoBudgetLimit',
    IsAllowKnowledgeCenter: 'IsAllowKnowledgeCenter',
    IsAllowAchievement: 'IsAllowAchievement',
    IsApprovalRequired: 'IsApprovalRequired',
} as const;

export default PARTNER_SETTINGS;
